<template>
  <v-container class="khmer" grid-list-xl>
    <v-layout row wrap align-center justify-center>
      <v-flex xs3>
        <v-img
          :src="imageSrc"
          lazy-src="@/assets/logo-bigger.png"
          class="white--text"
          aspect-ratio="1.7778"
          v-bind:height="getScreenSizeForImage()"
          v-bind:width="getScreenSizeForImage()"
          contain
        />
      </v-flex>
      <v-flex xs6>
        <h1 class="blue--text" v-bind:style="{ fontSize: getScreenSizeForFontSize() + 'px'}">{{ eventDetail.Title }}</h1>
        <h3 class="blue--text" v-bind:style="{ fontSize: getScreenSizeForSubFontSize() + 'px'}">{{ eventDetail.Location }} {{ moment(eventDetail.StartDateTime).format('DD/MM/YYYY') }} - {{ moment(eventDetail.EndDateTime).format('DD/MM/YYYY') }}</h3>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs12 sm8 offset-sm2 class="text-xs-center">
        <v-chip color="primary" class="custom-chip white--text" v-bind:style="{ height: getScreenSizeForChip() + 'px', width: getScreenSizeForChip() + 'px', fontSize: getScreenSizeForFontChip() + 'px'}">{{ counter }}</v-chip>
        <h2 class="blue--text" style="text-align: center;" v-bind:style="{ fontSize: getScreenSizeForFontSize() + 'px'}">ចំនួនវត្តមានសរុប</h2>
      </v-flex>
    </v-layout>
    <v-layout v-if="counter > 0">
      <v-flex xs12 sm8 offset-sm2>
        <div class="small">
          <BarChart :chart-data="getBarChartByAllDepartment()" :options="options"></BarChart>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex align-start justify-start xs12 v-for="(department, index) in getDepartments" v-bind:key="index">
        <v-card>
          <v-card-title primary-title style="background-color: #36A3E0;color: #FFFFFF; height: auto !important">
            <div class="flex" style="flex: 1; padding-left: 0; font-size: 13pt">{{ department.Name }}
            </div>
            <span style="display:flex; flex: 0.3; justify-content: flex-end; padding-right: 1px" class="count-chip-container">
              <v-chip label color="white" text-color="black" class="count-chip">
                {{ getCounterFilterDepartments(department) }}
              </v-chip>
              /
              <v-chip label text-color="white" color="blue" class="count-chip">
                  {{ getCounterFilterParentDepartments(department) }}
              </v-chip>
            </span>
          </v-card-title>
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>{{ department.Name }}</v-list-tile-content>
              <div v-if="department.Count > 0" class="count-chip-container">
                <v-chip text-color="white" color="green" class="count-chip">
                  {{ department.Count }}
                </v-chip>
                /
                <v-chip text-color="white" color="blue" class="count-chip">
                  {{ department.TotalCount }}
                </v-chip>
              </div>
              <div v-else class="count-chip-container">
                <v-chip text-color="white" color="red" class="count-chip">
                  {{ department.Count }}
                </v-chip>
                /
                <v-chip text-color="white" color="blue" class="count-chip">
                  {{ department.TotalCount }}
                </v-chip>
              </div>
            </v-list-tile>
            <v-list-tile v-for="(tmpDepartment, filterIndex) in getFilterDepartments(department)" v-bind:key="filterIndex">
              <v-list-tile-content>{{ tmpDepartment.Name }}</v-list-tile-content>
              <div v-if="tmpDepartment.Count > 0" class="count-chip-container">
                <v-chip text-color="white" color="green" class="count-chip">
                  {{ tmpDepartment.Count }}
                </v-chip>
                /
                <v-chip text-color="white" color="blue" class="count-chip">
                  {{ tmpDepartment.TotalCount }}
                </v-chip>
              </div>
              <div v-else class="count-chip-container">
                <v-chip text-color="white" color="red" class="count-chip">
                  {{ tmpDepartment.Count }}
                </v-chip>
                /
                <v-chip text-color="white" color="blue" class="count-chip">
                  {{ tmpDepartment.TotalCount }}
                </v-chip>
              </div>
            </v-list-tile>
          </v-list>
        </v-card>
        <!-- <BarChart :chart-data="getBarChartByDepartment(department)" :options="options" :height="window.height / 4" :width="window.width"></BarChart> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { types } from '../store';
import qs from 'qs';
import helper from '../services/helper';
import http from '../http';
import BarChart from './BarChart';
import _ from 'lodash';

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      getDepartments: [],
      allDepartments: [],
      getDepartsForChart: [],
      getDepartmentsCh: [],
      eventDetail: '',
      eventCode: '',
      isError: false,
      counter: 0,
      totalCount: 0,
      imageSrc: require('@/assets/moeys.png'),
      date: new Date().toISOString().substr(0, 10),
      window: {
        width: 0,
        height: 0,
      },
      tokenAuthentication: [],
      options: {
        legend: {
          display: true,
        },
        plugins: {
          datalabels: {
            color: 'white',
            display: context => context.dataset.data[context.dataIndex] > 5,
            font: {
              weight: 'bold',
            },
            formatter: Math.round,
            anchor: 'end',
            align: 'start',
          },
        },
      },
    };
  },
  mounted() {
    this.eventCode = this.$route.params.code;
    helper.clearToken();
    this.getClientToken();
    this.$nextTick(() => {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    });
  },
  created() {
    this.pollData();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getClientToken() {
      const objToken = {
        grant_type: 'client_credentials',
      };
      http.post('/token', qs.stringify(objToken)).then((respAuth) => {
        helper.setStorageData(types.SET_AUTH, respAuth.data);
        this.getAttendanceReport();
        this.getEventDetail();
      })
      .catch(() => {
        this.isError = true;
      });
    },
    getEventDetail() {
      http.get(`/event/detail/?Id=${this.eventCode}`).then((response) => {
        this.eventDetail = response.data;
      })
      .catch((error) => {
        console.dir(error);
        this.isError = true;
      });
    },
    getAttendanceReport() {
      http.get(`/event/attendance-report/?Id=${this.eventCode}&date=${this.date}`).then((response) => {
        this.getDepartments = _.filter(response.data.OrganizationalStructures, { ParentId: '' });
        this.allDepartments = response.data.OrganizationalStructures;
        this.counter = _.sumBy(this.allDepartments, 'Count');
        console.log(this.allDepartments);
        this.getDepartsForChart = _.filter(response.data.OrganizationalStructures, { ParentId: '' });
        this.getDepartmentsCh = response.data.OrganizationalStructures;
      })
      .catch((error) => {
        console.dir(error);
        this.isError = true;
      });
    },
    getFilterDepartments(department) {
      return this.allDepartments.filter(tmp => tmp.ParentId === department.Id);
    },
    getCounterFilterDepartments(department) {
      let counter = 0;
      this.allDepartments.filter(tmp => tmp.Id === department.Id).forEach((element) => {
        counter += element.Count;
      });
      this.allDepartments.filter(tmp => tmp.ParentId === department.Id).forEach((ele) => {
        counter += ele.Count;
      });
      return counter;
    },
    getCounterFilterParentDepartments(department) {
      let counter = 0;
      this.allDepartments.filter(tmp => tmp.Id === department.Id).forEach((element) => {
        counter += element.TotalCount;
      });
      this.allDepartments.filter(tmp => tmp.ParentId === department.Id).forEach((ele) => {
        counter += ele.TotalCount;
      });
      return counter;
    },
    getBarChartByDepartment(department) {
      const chartDepartments = [];
      const chartLabels = [];
      const chartColors = [];
      const simpleColors = [
        '#FFCDD2',
        '#F8BBD0',
        '#E1BEE7',
        '#D1C4E9',
        '#C5CAE9',
        '#BBDEFB',
        '#81D4FA',
        '#80DEEA',
        '#80CBC4',
        '#A5D6A7',
        '#C5E1A5',
        '#DCE775',
        '#00C853',
        '#76FF03',
        '#FFF59D',
        '#FFE082',
        '#FFB74D',
      ];
      this.allDepartments.filter(tmp => tmp.Id === department.Id).forEach((element, index) => {
        chartLabels.push(element.Name);
        chartColors.push(simpleColors(index));
        chartDepartments.push(element.TotalCount);
      });
      this.allDepartments.filter(tmp => tmp.ParentId === department.Id).forEach((ele, index) => {
        chartLabels.push(ele.Name);
        chartColors.push(simpleColors(index));
        chartDepartments.push(ele.TotalCount);
      });
      const tmp = {
        labels: chartLabels,
        datasets: [
          {
            label: 'Presention',
            backgroundColor: chartColors,
            data: chartDepartments,
          },
        ],
      };
      return tmp;
    },
    getBarChartByAllDepartment() {
      const chartDepartments = [];
      const chartLabels = [];
      const chartColors = [];
      const simpleColors = [
        '#800000',
        '#9A6324',
        '#808000',
        '#469990',
        '#000075',
        '#e6194B',
        '#f58231',
        '#ffe119',
        '#bfef45',
        '#3cb44b',
        '#42d4f4',
        '#4363d8',
        '#911eb4',
        '#f032e6',
        '#fabebe',
        '#fffac8',
        '#ffd8b1',
        '#aaffc3',
        '#e6beff',
      ];
      if (this.getDepartsForChart.length > 0) {
        this.getDepartsForChart.forEach((element, index) => {
          if (element != null) {
            let countValue = 0 + element.Count;
            const tmpDeparts = this.getDepartmentsCh.filter(tmp => tmp.ParentId === element.Id);
            if (tmpDeparts.length > 0) {
              tmpDeparts.forEach((temp) => {
                countValue += temp.Count;
              });
            }
            chartLabels.push(element.Name);
            chartColors.push(simpleColors[index]);
            chartDepartments.push(countValue);
          }
        });
      }
      const tmp = {
        labels: chartLabels,
        datasets: [
          {
            label: 'Presention',
            backgroundColor: chartColors,
            data: chartDepartments,
          },
        ],
      };
      return tmp;
    },
    getRandomInt() {
      return Math.floor(Math.random() * ((50 - 5) + 1)) + 5;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getRandomColor() {
      const letters = '0123456789ABCDEF'.split('');
      let color = '#';
      for (let i = 0; i < 6; i += 1) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getScreenSizeForFontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '16';
        case 'sm': return '18';
        case 'md': return '20';
        case 'lg': return '25';
        case 'xl': return '35';
        default: return '';
      }
    },
    getScreenSizeForSubFontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '12';
        case 'sm': return '14';
        case 'md': return '18';
        case 'lg': return '24';
        case 'xl': return '28';
        default: return '';
      }
    },
    getScreenSizeForImage() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '75';
        case 'sm': return '135';
        case 'md': return '145';
        case 'lg': return '155';
        case 'xl': return '165';
        default: return '100';
      }
    },
    getScreenSizeForFontChip() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '35';
        case 'sm': return '40';
        case 'md': return '45';
        case 'lg': return '55';
        case 'xl': return '60';
        default: return '';
      }
    },
    getScreenSizeForChip() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '85';
        case 'sm': return '100';
        case 'md': return '115';
        case 'lg': return '125';
        case 'xl': return '150';
        default: return '';
      }
    },
    pollData() {
      setInterval(() => {
        this.getAttendanceReport();
        this.counter = _.sumBy(this.allDepartments, 'Count');
      }, 20000);
    },
  },
  computed: {
    myStyles() {
      return {
        height: '300px',
      };
    },
  },
};
</script>
<style>
.headline, .title {
  font-family: 'Kantumruy', 'Roboto', sans-serif !important;
}
h1, h2 {
  font-family: 'Kantumruy', 'Roboto', sans-serif !important;
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.v-input .v-label {
  height: 50px !important;
  line-height: 27px !important;
  color: rgba(0,0,0,0.68) !important;
}
.v-input input {
    color: black !important;
    margin-top: 26px !important;
}
.custom-chip {
  border-radius: 50%;
  padding: 15px;
  justify-content: center;
  font-weight: bold;
}
.small {
  max-width: 600px;
  margin:  25px auto;
}
.count-chip {
  justify-content: center;
  width: 50px;
}
.count-chip-container {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/EventScanner.vue